import ContactForm from "./section/ContactForm";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json"
const Contact = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $ZEUSS Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      <div className="wrapper">
        <div className="pageback">
          <section className="Terms Contact">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="heading text-center">
                    <h4>Get In Touch</h4>
                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipis elit.</p> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-4">
                  <div className="contact-details">
                    <div>
                      <img src="/images/map.png" alt="" />
                    </div>
                    <div>
                      <h4>Address</h4>
                      <h3>1901 Thornridge Cir. Shiloh.</h3>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4">
                  <div className="contact-details">
                    <div>
                      <img src="/images/tel.png" alt="" />
                    </div>
                    <div>
                      <h4>Phone</h4>
                      <h3>+567890456</h3>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4">
                  <div className="contact-details">
                    <div>
                      <img src="/images/mail.png" alt="" />
                    </div>
                    <div>
                      <h4>Email</h4>
                      <h3>support@zeuss.one</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <ContactForm />
        </div>
      </div>
    </>
  );
};
export default Contact;
